import Copyright from '../componentes/copyright';
import Principal from '../componentes/principal';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import {withRouter} from 'react-router-dom';
import { Container } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import firebase from "firebase/app";
import 'firebase/firestore';
import React,{useCallback} from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';


const classes = makeStyles((theme) => ({
   paper: {
     marginTop: theme.spacing(8),
     display: 'flex',
     flexGrow: 1,
     flexDirection: 'column',
     alignItems: 'center',
   },
   title: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    menuButton: {
      marginRight: theme.spacing(2),
      marginTop: theme.spacing(20),
    },
    submit: {
      margin: theme.spacing(2, 2, 2),
  
     
  
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(2),
      },

      formControl:{
        margin: theme.spacing(2,0,2),
      },
}));

var tiposveiculos=[];
//****************************************************************carregar tipos veiculo***************** */

firebase.firestore().collection("tiposveiculo")
      .get()
      .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
              tiposveiculos.push({value: doc.id, label: doc.data().tipoveiculo});
          });
      })
      .catch(function(error) {
          console.log("Error getting documents: ", error);
      });
      
      console.log('[tipos de veiculos]',tiposveiculos);

    

//**************************************************************************************************** */
document.title = 'Frota UFSM'
document.logo=''



export const  Cadastrarveiculo = withRouter(({history}) => {
   
  const handleconsultar=()=>{
    history.push('/Veiculos');
  }

const [stateautcomp, setStateautcomp] = React.useState('');
  //**********************************valor autocoplete */
  
   /////////////////////////////*****************************************////////// */

   function cadastrando (){
       
        

    
      var modelo = document.getElementById('modelo').value;
      var placa = document.getElementById('placa').value;
      var marca = document.getElementById('marca').value;
      var kilometro = document.getElementById('km').value;
      const tipo=document.getElementById("combotipo").value;
      var capacidade = document.getElementById('capcarga').value;
      var passag=document.getElementById("passageiros").value;
      var ano = document.getElementById("ano").value;
      var lotacao = lot;
      var status = true;
      
      
      
         

     
            var db = firebase.firestore();
            db.collection("veiculos").add({ lotacao: lotacao,
                  modelo: modelo, placa: placa, km: kilometro, ano: ano, marca: marca,
                  tipoveiculo: tipo, capacidadecarga: capacidade, npassageiros: passag,
                  status: status
                }).then(function () {
                  alert('Cadastro Realizado com Sucesso');
              }).catch(function (error) {
                    var errorMessage = error.message;
          
                  alert(errorMessage);
                  })



             


              history.push('/veiculos');
              
       
      //
               
                }
   
  ;
   /////////****************controle lotação*******************/////////////////////////////////// */

   const [lot, setlot] = React.useState("");
   const handlelotacao = (event) => {
     setlot(event.target.value);
   };

   //******************************************************************************** */
 
return(
 
<Container >

<CssBaseline />
      
      <div id="cabeça" >
      <Principal/>
      
      
      </div>
      
      <Typography className={classes.title} variant="h5" noWrap align="center">
            Veículos
          </Typography>
      <div id="corpo"   maxWidth="xs" align="center" className={classes.paper} >

      <Grid container >
            <Grid item>
            </Grid>

            <Grid item>
            </Grid>

            <Grid item xs>
            </Grid>
            
            <Grid item xs>
            </Grid>
            
            <Grid item xs>
                <Button
                onClick={handleconsultar}
                variant="contained"
                  color="primary"
                  className={classes.submit}
                  >
                  Consultar
                </Button>
            </Grid>
            
           </Grid>

        <Container maxWidth="xs">
           <div id="corpoveiculo" className={classes.paper}>

             
           <Typography component="h4" variant="h5">
         Preencha os Dados do Veículo.
        </Typography>

           <form className={classes.form} onSubmit={cadastrando} noValidate={false}>
        
       
           <FormControl  fullWidth variant="outlined"  className={classes.formControl}>
          <InputLabel htmlFor="lotacao">Lotação</InputLabel>
          <Select
          required
          labelId="selectlotacao"
          id="selectlotacao"
          value={lot}
          onChange={handlelotacao}
          label="selectcampichefe"

                   
        >
          <MenuItem value="">
            <em></em>
          </MenuItem>
          <MenuItem key = {1} value={"Campi Santa Maria"}>Campi Santa Maria</MenuItem>
          <MenuItem key = {2} value={"Campi Cachoeira do Sul"}>Campi Cachoeira do Sul</MenuItem>
          <MenuItem key = {3} value={"Campi Frederico Westphalen"}>Campi Frederico Westphalen</MenuItem>
          <MenuItem key = {4} value={"Campi Palmeira das Missões"}>Campi Palmeira das Missões</MenuItem>
        </Select>
          
         
        
      </FormControl>

       
        <TextField
            variant="outlined"
            margin="normal"
            //onChange={ e=>setEmail(e.target.value)}
            required
            type="nome"
            fullWidth
            id="modelo"
            label="Modelo do veículo"
            name="modelo"
            
            
          />


                   <TextField
                    
                    variant="outlined"
                    margin="normal"
                    //onChange={ e=>setEmail(e.target.value)}
                    required
                    type="phoneNumber"
                    fullWidth
                    id="placa"
                    label="Placa do Veículor"
                    name="placa"
                    
                    
                    />   
              
              <TextField
            variant="outlined"
            margin="normal"
            //onChange={ e=>setEmail(e.target.value)}
            required
            type="mail"
            fullWidth
            id="ano"
            label="Ano"
            name="ano"
            
            
            
          />             
              
              <TextField
            variant="outlined"
            margin="normal"
            //onChange={ e=>setEmail(e.target.value)}
            required
            type="nu"
            fullWidth
            id="km"
            label="Km"
            name="km"
            />
               

          <TextField
            variant="outlined"
            margin="normal"
            //onChange={ e=>setEmail(e.target.value)}
            required
            type=""
            fullWidth
            id="marca"
            label="Marca do Veiculo"
            name="marca"
                 
          />


                    
             <Autocomplete
                 className={classes.formControl}
                  id="combotipo"
                  options={tiposveiculos}
                  getOptionLabel={(option) => option.label}
                 defaultValue={stateautcomp}
                 onChange={(e,v) => setStateautcomp(v.label)}
                  renderInput={(params) => <TextField {...params}   required label="Tipo de Veículo" variant="outlined" />}
                />
                
                
               

     
            

          <TextField
            variant="outlined"
            margin="normal"
            //onChange={ e=>setEmail(e.target.value)}
            required
            type="mail"
            fullWidth
            id="capcarga"
            label="Capacidade de Carga"
            name="capcarga"
            
            
            
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            //onInput={ e=>setPassword(e.target.value)}
            name="passageiros"
            label="Numero de Passageiros (com motoristas)"
            type=""
            id="passageiros"
            
          />

            
           <Typography component="h7" variant="h10">
         * Preenchimento obrigatório 
        </Typography>

        
      
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            //onClick = {cadastrando}        
              >
            Cadastrar
          </Button>
                    
        </form>




           </div>
           </Container>
          
          
      </div>
       
  
       <Box mt={3}>
          <Copyright/>
       </Box>
   
   
   </Container>
)

}

)
 
export default Cadastrarveiculo;
